<style lang="scss" scoped>
  @import '../styles/vars/main';
  @import '../styles/helpers/main';
  //reset
  h1,h2,h3,h4,h5,h6 {
    font-weight: normal;
    margin: 0;
  }

  //styles
  .headline {
    font-family: $firaSans;
    font-weight: 500;
    color: color("white");
    &.\--peta{
      font-size: font-size("peta");
    }
    &.\--tera {
      font-size: font-size("tera");
    }
    &.\--giga {
      font-size: font-size("giga");
    }
    &.\--mega {
      font-size: font-size("mega");
    }
    &.\--kilo {
      font-size: font-size("kilo");
    }
    &.\--hecto {
      font-size: font-size("hecto");
    }
    &.\--nile {
      color: color("nile");
    }
    &.\--black {
      color: color("black");
    }
  }
</style>
<template>
  <h1 v-if="level === '1'" class="headline" :class="cssClass">
    <slot></slot>
  </h1>
  <h2 v-else-if="level === '2'" class="headline" :class="cssClass">
    <slot></slot>
  </h2>
  <h3 v-else-if="level === '3'" class="headline" :class="cssClass">
    <slot></slot>
  </h3>
  <h4 v-else-if="level === '4'" class="headline" :class="cssClass">
    <slot></slot>
  </h4>
</template>
<script>
// import myFile from'./pathToMyFile';

export default {
  data() {
    return {

    };
  },
  props: {
    cssClass: {
      type: String,
      default: ''
    },
    level: {
      type: String,
      default: '',
      required: true
    }
  },
  mounted() {

  },
  computed: {

  },
  methods: {

  }
};
</script>



// WEBPACK FOOTER //
// src/components/headline.vue